import type { ICalloutContentStyles } from '@fluentui/react/lib/Callout';

const generateDropdownCalloutStyles = (overrides?: ICalloutContentStyles) => {
    return {
        root: [{ width: 'auto !important' }, overrides?.root], // override width constant so dropdown with is based on item width
    };
};

export default generateDropdownCalloutStyles;
